import { Pipe, PipeTransform } from '@angular/core';

import { TableHeader } from 'src/app/table-handling';
import { isSpecialHeader } from 'src/app/table-handling/construction/special-headers';

@Pipe({
  name: 'validRegularHeader',
  standalone: true,
})
export class ValidRegularHeaderPipe implements PipeTransform {
  public transform(header: TableHeader): boolean {
    return !!header && !isSpecialHeader(header) && header.column >= 0;
  }
}

